/* Desktop click-and-drag scrolling for horizontal sliders marked [data-serie-drag]
   (e.g. the related-col "you may like" rows). Touch devices keep native scrolling.
   A real drag suppresses the following click so cards don't navigate. */
(function () {
  if (window.__serieDragInit) return;
  window.__serieDragInit = true;

  var DRAG_THRESHOLD = 6;

  function enableDrag(track) {
    if (track.__serieDragBound) return;
    track.__serieDragBound = true;

    var isDown = false;
    var moved = false;
    var captured = false;
    var startX = 0;
    var startScroll = 0;
    var activePointer = null;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // native touch scroll
      if (e.button !== 0) return; // primary button only
      // Don't hijack presses on interactive controls (colour dots, buttons) so
      // their own click still fires.
      if (e.target.closest('.serie-dot, button, [data-serie-color]')) return;
      isDown = true;
      moved = false;
      captured = false;
      activePointer = e.pointerId;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      // Deliberately NOT capturing the pointer here: capturing on pointerdown
      // swallows the follow-up click on a card, so a plain click wouldn't open
      // the product. We only start capturing once an actual drag begins.
    });

    track.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > DRAG_THRESHOLD) {
        moved = true;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(activePointer); captured = true; } catch (err) {}
      }
      if (moved) {
        track.scrollLeft = startScroll - dx;
      }
    });

    function end() {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
      if (captured) {
        try { track.releasePointerCapture(activePointer); } catch (err) {}
        captured = false;
      }
    }
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);

    // Cancel the click that follows a real drag so cards/links don't fire.
    track.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      },
      true
    );

    // Stop the browser's native image/link drag from hijacking the gesture.
    track.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-serie-drag]').forEach(enableDrag);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
